import ProfileModel from "../ProfileModel";
import ProfileCountryModel from "../ProfileCountryModel";
import DetailedProfileModel from "../DetailedProfileModel";
import { PreferenceModel } from "../../../../../models";

export default class ProfileRemapper {

    public profilesFromResponse = (response: any): ProfileModel[] => {
        if (response) {
            return response.map((profResp: any) => this.publicProfileFromResponse(profResp));
        } else {
            return null;
        }
    };

    public fullProfileFromResponse = (response: any): DetailedProfileModel => {
        const model: DetailedProfileModel = new DetailedProfileModel();

        model.id = response.id;
        model.name = response.name;
        model.email = response.email;
        model.nickname = response.nickname;
        model.avatar = response.avatar;
        model.gender = response.gender;
        model.country = response.country as ProfileCountryModel;
        model.birthDate = response.birth_date;
        model.phoneCountryCode = response.phone_country_code;
        model.phoneNumber = response.phone_number;
        model.verified = response.verified;
        model.staffMember = response.staff_member;
        model.anonymous = response.anonymous;
        model.disabled = response.disabled;
        model.interests = response.interests ? response.interests : [];
        model.preferences = response.preferences ? this.remapPreferences(response.preferences) : [];
        model.consentIds = response.consent_ids ? response.consent_ids : [];
        model.followingCount = response.following_count;
        model.followersCount = response.followers_count;

        return model;
    };

    public publicProfileFromResponse = (response: any): ProfileModel => {
        const model: ProfileModel = new ProfileModel();

        model.id = response.id;
        model.name = response.name;
        model.nickname = response.nickname;
        model.avatar = response.avatar;
        model.gender = response.gender;
        model.country = response.country as ProfileCountryModel;
        model.birthDate = response.birth_date;
        model.verified = response.verified;
        model.staffMember = response.staff_member;
        model.anonymous = response.anonymous;
        model.disabled = response.disabled;
        model.interests = response.interests ? response.interests : [];
        model.followingCount = response.following_count;
        model.followersCount = response.followers_count;

        return model;
    };

    private remapPreferences = (preferences: any[]): PreferenceModel[] => {
        return preferences.map((pref: any) => {
            return {
                preferenceId: pref.preference_id,
                categories: pref.categories,
                source: pref.source
            };
        });
    }
}
